<template>
    <div class="modal-full">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Create Promotion</h1>
        </div>
        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="promotion-body">
                    <div class="form-field">
                        <label>Title</label>
                        <input type="text" v-model="promotion.title" placeholder="Title">
                    </div>
                    <div class="form-field">
                        <label>Description</label>
                        <input type="text" v-model="promotion.description" placeholder="Description">
                    </div>
                    <div class="form-field">
                        <label>Code</label>
                        <input type="text" v-model="promotion.code" placeholder="Code">
                    </div>
                    <div class="form-field">
                        <label>Products</label>
                        <picker-selector placeholder="Select Products"
                                         :value="promotionProducts"
                                         input-name="products[]"
                                         @input="addProduct"
                                         route="products.select">
                        </picker-selector>
                    </div>
                    <div class="form-field">
                        <label>Packages</label>
                        <picker-selector placeholder="Select Packages"
                                         :value="promotionPackages"
                                         input-name="packages[]"
                                         @input="addPackage"
                                         route="packages.select">
                        </picker-selector>
                    </div>
                    <div class="promotion-type">
                        <input type="radio" name="type" v-model="promotionType" value="percentage"/>
                        <label>Discount by Percentage</label>
                        <input type="radio" name="type" v-model="promotionType" value="fixed_amount"/>
                        <label>Discount by Fixed Amount</label>
                    </div>
                    <div class="form-field discount" v-show="promotionType === 'percentage'">
                        <label>Percentage</label>
                        <input type="number" v-model="promotion.percentage" placeholder="50">
                    </div>
                    <div class="form-field discount" v-show="promotionType === 'fixed_amount'">
                        <label>Fixed Value</label>
                        <input type="number" v-model="promotion.fixed_amount" placeholder="25.00">
                        <p class="text-sm text-gray-600 mt-1">
                            <fa-icon icon="question-circle"></fa-icon>
                            <strong>IMPORTANT</strong> Enter fixed value discounts as gross (including VAT) values -
                            i.e: to discount our Standard Annual package from £396.00 per year (gross) to £200.00 per
                            year (gross), enter 196.00 in this box
                        </p>
                    </div>
                    <div class="form-field">
                        <label>Expiry Date</label>
                        <simple-date-time-picker
                            v-model="promotion.expires">
                        </simple-date-time-picker>
                    </div>
                    <div class="form-field">
                        <label>Number of Uses</label>
                        <input type="number" v-model="promotion.max_uses" placeholder="1">
                    </div>
                    <div class="form-field">
                        <label>Number of Uses per User</label>
                        <input type="number" v-model="promotion.max_uses_user" placeholder="1">
                    </div>
                    <div class="form-field">
                        <label>Months Active</label>
                        <input type="number" v-model="months" placeholder="1">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="flex">

                <div class="middle text-middle">

                </div>

                <div class="right text-right">
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="savePromotion">Save</button>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
export default {
    name: 'PromotionsCreate',
    props: {},
    data() {
        return {
            promotion: {
                title: null,
                code: null,
                max_uses: 1,
                max_uses_user: 1
            },
            promotionPackages: [],
            promotionProducts: [],
            promotionType: 'percentage',
            months: 1,
        }
    },
    mounted() {
        this.setMetaTitle('Create Promotion | JournoLink Control')
    },
    beforeDestroy() {
        //
    },
    methods: {
        savePromotion() {
            this.promotion.expires = this.moment(this.promotion.expires).format('YYYY-MM-DD HH:mm:ss')
            axios.post(route('promotions.create'),
                {
                    "promotion": this.promotion,
                    "packages": this.promotionPackages,
                    "products": this.promotionProducts,
                    "type": this.promotionType,
                    "months": this.months,
                }
            ).then(response => {
                this.$bus.$emit('alert.success', 'Update Success')

                this.promotion = response.data.promotion
                this.promotionPackages = response.data.packages
                this.promotionProducts = response.data.products
                this.promotionType = response.data.type

                this.closeView()
            }).catch(e => {
                console.error({e})
            })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        addPackage(ids) {
            this.promotionPackages = ids
        },
        addProduct(ids) {
            this.promotionProducts = ids
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
    },
    computed: {
        //
    }
}
</script>

<style lang="less">

.promotion-body {
    flex: 1;
    padding: 15px;
}

.promotion-type {
    margin: 20px 0 5px;

    input {
        margin-left: 20px;

        &:first-child {
            margin-left: 0;
        }
    }
}

</style>
